import isNumber from 'lodash/isNumber.js';
import PendoIcon from '../../icon/pendo-icon.vue.js';
import ColorPickerCheckboard from './color-picker-checkboard.vue.js';
import { isValidHex, getContrastingColor, getAlpha } from '../../../utils/color.js';

var script = {
  name: 'ColorPickerSwatch',
  components: {
    PendoIcon,
    ColorPickerCheckboard
  },
  props: {
    value: {
      type: String,
      default: null,
      validator: value => isValidHex(value)
    },
    color: {
      type: String,
      required: true
    },
    size: {
      type: [String, Number],
      default: 16
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    styleObj() {
      if (isNumber(this.size)) {
        return {
          width: `${this.size}px`,
          height: `${this.size}px`
        };
      }
      return {
        width: this.size,
        height: this.size
      };
    },
    selectedIconProps() {
      return {
        type: 'check',
        strokeWidth: 2.5,
        stroke: getContrastingColor(this.value),
        size: this.size * 0.6
      };
    },
    isTransparent() {
      return getAlpha(this.color) !== 1;
    },
    isSelected() {
      if (this.value) {
        return this.color.toLowerCase() === this.value.toLowerCase();
      }
      return false;
    }
  }
};

export { script as default };
//# sourceMappingURL=color-picker-swatch.vue2.js.map
